let funcs = {

    getDistance: (first, second) => {
        let lat1 = first.lat;
        let lon1 = first.lon;
        let lat2 = second.lat;
        let lon2 = second.lon;

        const R = 6371e3 // meter
        const φ1 = lat1 * Math.PI / 180 // φ, λ in radians
        const φ2 = lat2 * Math.PI / 180
        const Δφ = (lat2 - lat1) * Math.PI / 180
        const Δλ = (lon2 - lon1) * Math.PI / 180

        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

        return R * c
    },

    getPlaygroundLocation: (playground) => {
        if (!playground || !playground.location || !playground.location.coordinates) {
            return false;
        }

        let c = playground.location.coordinates;
        return { lat: c[1], lon: c[0] };
    }
}

export default funcs;